import { lastActiveProfileFilterAtom } from 'atoms/filters/rsim-products';

import ToggleButton from '@mui/material/ToggleButton';
import { ToggleGroup } from 'common/components/Inputs/ToggleGroup/ToggleGroup';
import { useAtom } from 'jotai';
import { ACTIVE_PROFILE_FILTER } from 'src/rSimInventory/constants/activeProfile';

export const LastActiveProfileInput = () => {
  const [lastActiveProfile, setLastActiveProfile] = useAtom(lastActiveProfileFilterAtom);

  return (
    <ToggleGroup
      sx={{
        width: '100%',
        justifyContent: 'stretch',
      }}
      value={lastActiveProfile}
      onChange={(_event, value) => {
        if (value === null) {
          return;
        }

        setLastActiveProfile(value);
      }}
    >
      <ToggleButton sx={{ flex: 1 }} value={ACTIVE_PROFILE_FILTER.PRIMARY}>
        Primary
      </ToggleButton>
      <ToggleButton sx={{ flex: 1 }} value={ACTIVE_PROFILE_FILTER.ANY}>
        Any
      </ToggleButton>
      <ToggleButton sx={{ flex: 1 }} value={ACTIVE_PROFILE_FILTER.SECONDARY}>
        Secondary
      </ToggleButton>
    </ToggleGroup>
  );
};
